import {Component, OnInit} from '@angular/core';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {BundeslandFilterService} from '../../../../../service/bundeslandFilter/bundesland-filter.service';
import {BundesLandName} from '../../../../../model/component/bundesland';

@Component({
  selector: 'app-wetterbericht',
  templateUrl: './wetterbericht.component.html',
  styleUrls: ['./wetterbericht.component.css']
})
export class WetterberichtComponent implements OnInit {
  BERLIN: string = BundesLandName.BE;
  BRANDENBURG: string = BundesLandName.BB;
  BREMEN: string = BundesLandName.HB;
  NRW: string = BundesLandName.NW;
  BAYERN: string = BundesLandName.BY;
  bundeslandName = BundesLandName;
  selectedIndex = 0;
  selectedBundesland: string;

  constructor(public bundeslandFilterService: BundeslandFilterService) {
    this.selectedBundesland = this.bundeslandFilterService.selectedBundesLand.name;
  }

  onTabChange($event: MatTabChangeEvent) {
    this.selectedBundesland = $event.tab.textLabel;
    this.selectedIndex = 0;
  }

  ngOnInit() {
    // console.log('selectedBundesland ' + this.selectedBundesland);
  }
}
